module.exports = __webpack_public_path__ + "img/flag_98.c48cc333.png";